import React from 'react';
import type { IMessage } from '@/types/admin/messages';
import { isMessageSentByUser, formatSenderName } from '@/utils/residents/messages/messageUtils';
import { BaseMessageBubble, MARKETPLACE_BUBBLE_THEME } from '@/components/common/chat';
import { RESIDENTS_DESKTOP_COLORS } from '@/constants/residents/desktop/color';

// Property chat theme - dark mode style
const PROPERTY_CHAT_THEME = {
  ...MARKETPLACE_BUBBLE_THEME,
  sentBubbleColor: '#4773FE',
  receivedBubbleColor: '#1f1f1f',
  receivedBubbleBorderColor: RESIDENTS_DESKTOP_COLORS.BORDER_SECONDARY,
};

interface MessageBubbleProps {
  message: IMessage;
  authUserId?: number;
}

/**
 * Message bubble component for property chat.
 * Wraps the BaseMessageBubble with property chat-specific theming.
 */
export const MessageBubble: React.FC<MessageBubbleProps> = ({ message, authUserId }) => {
  const sentByYou = isMessageSentByUser(message.sender?.id, authUserId, message.isAdmin);
  const senderName = formatSenderName(message, sentByYou, 'desktop');

  // Property chat uses a different theme based on whether it's an admin message
  const theme = {
    ...PROPERTY_CHAT_THEME,
    // No border for admin messages
    receivedBubbleBorderColor: message.isAdmin ? undefined : PROPERTY_CHAT_THEME.receivedBubbleBorderColor,
  };

  return (
    <BaseMessageBubble
      text={message.content}
      timestamp={message.createdAt}
      isSent={sentByYou}
      senderName={senderName}
      theme={theme}
      showSenderName={message.isAdmin}
      senderNameAtBottom={!message.isAdmin}
    />
  );
};

export default MessageBubble;
